module.exports = __webpack_public_path__ + "static/media/la-picture-1.926574f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/LA/la-picture-1.jpg
// module id = 663
// module chunks = 1 6